export default function(BaseRealTimeNotifications) {
	return class RealTimeNotifications extends BaseRealTimeNotifications {};
}
